<template>
<div class="chapter">
<div class="inner_page">
<p class="c5" id="calibre_pb_2" lang="de-DE" xml:lang="de-DE"> <br class="calibre2"/></p>
<p class="c6">Acknowledgments</p>
<p class="western1"> <br class="calibre2"/></p>
<p class="c6">I would like to thank my family, friends, and fans
for encouraging me to write and for believing in this series from
the start. Thank you Megan, Stephanie, Lori, and Lindsay for all of
your help, feedback, and excitement about this series and
especially this book. Thank you Jarred Johnson for helping me come
up with this book’s title. And I would like to thank Jacob from
Permuted Press for having faith in me as well as this series.</p>
<p class="c6"> <br class="calibre2"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_0a9fca13b620a2de592dddca89bae7c7_34PU7E.ch.fixed.fc.tidied.stylehacked.xfixed_split_003.vue?59c7a37d